import React from 'react';
import GifVideoAsset, { GifVideoAssetProps } from '../components/GifVideoAsset';
import { useVideoClipAsset, UseVideoClipAssetProps } from './VideoClipAsset';

export type GifVideoClipAssetProps = UseVideoClipAssetProps &
  Pick<GifVideoAssetProps, 'aspectRatio'>;

export default function GifVideoClipAsset(props: GifVideoClipAssetProps) {
  const videoAssetData = useVideoClipAsset(props);
  return <GifVideoAsset {...videoAssetData} {...props} />;
}
